import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import type { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import MultiSelectSortable, { ReactSelectOption } from './SortableSelect';

export interface TestMultiSelectorProps {
  readOnly?: boolean;
  selectedTestIds?: string[];
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
}

export default (props: TestMultiSelectorProps) => {
  const spd = useSpdCore();
  const [tests, setTests] = useState<ReactSelectOption[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<ReactSelectOption[]>(
    [],
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.tests
      .getAll()
      .then(allTests => {
        if (mounted) {
          const result = allTests
            .filter(test => test.active)
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
            .map(
              test =>
                ({
                  value: test.id,
                  label: test.name || '',
                }) as ReactSelectOption,
            );
          setTests(result);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem testów. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.tests]);

  useEffect(() => {
    if (props.selectedTestIds && tests.length > 0) {
      const selected = tests.filter(test =>
        props.selectedTestIds?.includes(test.value),
      );
      setSelectedOptions(selected);
    } else {
      setSelectedOptions([]);
    }
  }, [props.selectedTestIds, tests]);

  return ready ? (
    <MultiSelectSortable
      options={tests}
      defaultValue={selectedOptions}
      onChange={options => props.onChange && props.onChange(options)}
    />
  ) : (
    <Skeleton />
  );
};
